import { render, staticRenderFns } from "./satisfactionRate.vue?vue&type=template&id=04372e51&scoped=true&"
import script from "./satisfactionRate.vue?vue&type=script&lang=js&"
export * from "./satisfactionRate.vue?vue&type=script&lang=js&"
import style0 from "./satisfactionRate.vue?vue&type=style&index=0&id=04372e51&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04372e51",
  null
  
)

export default component.exports